<template>
    <Head title="Log in" />
    <bernstein-layout> 

     <!-- {{users}} -->
     <div class=" flex justify-center mx-auto py-4 my-2 min-h-screen  ">
         
         <div class="w-full   ">
             <div class="border-b border-gray-200 shadow">
                 <table class="mx-auto">
                      <thead>
                        <tr class="font-bold bg-gray-200 py-2 px-2" > 
                            <th class="px-6 py-2 text-xs text-gray-600 text-left">  
                             S.N. 
                             </th>

                            <th class="px-6 py-2 text-xs text-gray-600 text-left">  
                              Name  
                          </th>
                           <!-- email  -->
                            <th class="px-6 py-2 text-xs text-gray-600 text-left">  
                              Email 
                          </th>
                             <!-- Rolle  -->
                            <th class="px-6 py-2 text-xs text-gray-600 text-left">  
                              Rolle  
                          </th>
                          <th class="px-6 py-2 text-xs text-gray-600 text-left">  
                                Rolle Bearbeiten  
                          </th>
                            <th class="px-6 py-2 text-xs text-gray-600 text-left">  
                             Benutzer Entfernen  
                          </th>
                            
                        </tr>
                      </thead>
                      <tbody class="bg-gray-50">
                            <tr class="whitespace-nowrap border-b border-gray-200"  
                            v-for="(user, uIndx) in users  " :key="uIndx" >
                            <td class="px-6 py-4 text-sm text-gray-500">
                              {{ uIndx+1 }}
                            </td>
                            <td class="px-6 py-4">
                                <div class="text-sm text-gray-900">
                                    {{user.name}}
                                </div>
                            </td>
                              <!-- email  -->
                               <td class="px-6 py-4">
                                <div class="text-sm text-gray-900">
                                    {{user.email}} 
                                </div>
                            </td>
                               <!-- Rolle   -->
                                <td class="px-6 py-4">
                                <div class="text-sm text-gray-900">
                                    <!-- {{user.role}} -->
                                    <div  v-for="(role, rIndx) in user.role" :key="rIndx" > 
                                        <span>  {{role}} </span>
                                        <!-- <span v-if = "(rIndx)== role.length" >,  </span>  -->
                                    </div>  
                                
                                </div>
                            </td>
                              <!-- Edit button  -->
                               <!-- v-model.lazy ="form.name"  -->
                                  <!-- <input type="text" 
                                     :id ="uIndx"                                     
                                     :value= "user.name"                                      
                                     @input ="addName"  />
                                        <input type="text" 
                                      :model-value= "form.name" 
                                      @update:model-value="form.name = $event"
                                     v-bind:value="user.name"                                      
                                   @input="$emit('update:modelValue', $event.target.value)" />   
                                   @update:model-value="form.name = $event"
                                    <input :value="user.name" 
                                     @change = "form.name = $event.target.value" />
                                      <input type="text" :value="user.name" @input="e => form.name = e.target.value">
                         
                                         
  -->
                            <td class="px-6 py-4">
                                    <form @submit.prevent="submit">
                                   
                               <input type="text" :value="user.name" name = "name"  class="hidden">
                               <input type="text" :value="user.email" name = "email" class="hidden" >
                               <input type="text"  value="edit" name = "action"  class="hidden" >
                               
                               <!-- <input v-bind:value="user.email" v-on:input="form.email = $event.target.value" /> -->
                             
                                 <button type="submit" 
                                        class="px-4 py-1 text-sm text-white bg-blue-400 rounded">
                                       Bearbeiten
                                    </button>
                                     </form> 

                            </td> 
                            <td class="px-6 py-4">
                                 <form @submit.prevent="submit">
                                     <input type="text" :value="user.name" name = "name"  class="hidden">
                                     <input type="text" :value="user.email" name = "email" class="hidden" >
                                    <input type="text"  value="delete" name = "action"  class="hidden" >
                               
                                   
                                     <button type="submit" class="px-4 py-1 text-sm text-white bg-red-400 rounded">
                                        Löschen
                                    </button>
                                  </form>
                            </td>
                            </tr> 
                      </tbody>
                 </table>
             </div>

         </div>

     </div>
     
    </bernstein-layout>
</template>
<script>
    import BernsteinLayout from '@/Layouts/BernsteinLayout.vue'
    import { Head  } from '@inertiajs/inertia-vue3'
import { reactive } from '@vue/reactivity'
//  import { reactive } from 'vue'
 import { Inertia } from '@inertiajs/inertia'
import { watchEffect } from '@vue/runtime-core'

export default {
    components:{
        BernsteinLayout,
        Head 
    },
        
   props:{
    'users': Array ,
    'roles': Array  
   },
   setup(){
       const form  =reactive({
          name :  "",
          email:  "",
          action: ""  
       })
        function submit(event) {
            const {name, email, action } = Object.fromEntries(new FormData(event.target));
             form.name =name, 
             form.email = email 
             form.action = action 
              Inertia.post('/user_roles', form)
        }
        // watchEffect(() => console.log("Value: " + form.vname))
        return { form, submit }

   },
   
   methods:{ 
       addName ($event,$user){
           this.form.name = parseInt($event.target.value);
           console.log($event.target.value); 
       }
   } 

}
</script>
<style scoped>
 .roleRow{
     @apply px-6 py-2 text-xs text-gray-500 border-b border-gray-200
 }
</style>